'use client';

import { useEffect, useState } from 'react';

export const usePreviewToolbarPortal = (wrapperId: string): HTMLElement | null => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let wrapper: HTMLElement | null = null;

    const attach = () => {
      const panel = document.querySelector('.live-preview-toolbar-controls');
      if (!panel || wrapper) return;
      wrapper = document.createElement('div');
      wrapper.id = wrapperId;
      panel.prepend(wrapper);
      setPortalTarget(wrapper);
    };

    attach();

    const observer = new MutationObserver(() => {
      attach();
      if (wrapper) observer.disconnect();
    });

    if (!wrapper) observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      wrapper?.parentNode?.removeChild(wrapper);
    };
  }, [wrapperId]);

  return portalTarget;
};
